/* eslint-disable */
import { ComponentProps, createContext, FC, ReactElement, useContext, useReducer } from 'react';
import { authReducer, initialAuthState } from './reducers/AuthReducer';
import { checkAdminPortal, loginUser, logoutUser } from './actions/AuthActions';
import { AuthModel } from './mappers/AuthTypesMapper';

interface AuthContextInterface {
  readonly authState: AuthModel;
  readonly logout: () => void;
  readonly login: (data: object) => void;
  readonly isAdminPortal: (data: object) => void;
}

const AuthContext = createContext<AuthContextInterface>({} as AuthContextInterface);

export const useAuthContext = (): AuthContextInterface => useContext(AuthContext);

export const AuthContextProvider = ({
  children,
}: ComponentProps<FC<any>> & { children: ReactElement }): JSX.Element => {
  const [authState, dispatch] = useReducer(authReducer, initialAuthState);

  const logout = (): void => {
    logoutUser(dispatch);
  };

  const login = (data: any): void => {
    loginUser(dispatch, data);
  };
  const isAdminPortal = (data: any): void => {
    checkAdminPortal(dispatch, data);
  };
  {
    /* eslint-disable-next-line react/jsx-no-constructed-context-values */
  }
  return (
    <AuthContext.Provider value={{ authState, logout, login, isAdminPortal }}>
      {children}
    </AuthContext.Provider>
  );
};
